import { CompletedIcon, gearIcon } from "@/designSystemIcons";
import { cn } from "@/lib/utils";
import { BREAKPOINTS } from "@/settings";
import { useMediaQuery } from "usehooks-ts";

type Props = {
  onHandleRemoveAndCompletePlayers: () => void;
  onHandleSolveAgain: () => void;
  isUsingClubImport: boolean;
  handleUncompleteSBC: () => void;
  onToggleFiltersBar?: () => void;
  hideGearIcon?: boolean;
  isCompleted?: boolean;
  isSolving?: boolean;
};

export const CompleteAndSolveAgain = ({
  onHandleRemoveAndCompletePlayers,
  onHandleSolveAgain,
  handleUncompleteSBC,
  onToggleFiltersBar,
  hideGearIcon = false,
  isCompleted,
  isSolving,
}: Props) => {
  const done = Boolean(isCompleted);
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  const handleComplete = () => {
    if (done) return;
    onHandleRemoveAndCompletePlayers();
  };

  return (
    <div
      className={cn(
        "w-full flex items-center",
        isMobile
          ? "h-20 gap-4 px-4 bg-panel-base justify-between"
          : "h-16 gap-3 justify-center bg-transparent px-0",
      )}
    >
      <button
        type="button"
        className={cn(
          "rounded-sm text-dark-primary w-28",
          isMobile ? "h-9 px-3 text-base" : "h-8 px-3 text-sm",
          !done && "bg-[#0576C7]",
          done && "flex items-center gap-2 cursor-default",
          isSolving && !done && "bg-disabled text-dark-disabled cursor-default",
        )}
        onClick={handleComplete}
        disabled={done || isSolving}
      >
        {done ? (
          <>
            <span className="text-complete">Completed</span>
            <div className="flex-none">
              <CompletedIcon fill="#03E46B" height={"16"} width={"16"} />
            </div>
          </>
        ) : (
          "Complete"
        )}
      </button>

      {isMobile ? (
        <div className="flex items-center gap-4">
          <button
            type="button"
            className={cn(
              "bg-panel-foreground text-base rounded-sm h-9 px-4 whitespace-nowrap",
              isSolving && "bg-disabled text-dark-disabled cursor-default",
            )}
            onClick={() => {
              window.scrollTo(0, 0);
              onHandleSolveAgain();
              if (isCompleted) {
                handleUncompleteSBC();
              }
            }}
          >
            Solve Again
          </button>
          {!hideGearIcon && (
            <button
              type="button"
              className="bg-panel-foreground text-base rounded-sm h-9 px-4 whitespace-nowrap"
              onClick={onToggleFiltersBar}
            >
              {gearIcon}
            </button>
          )}
        </div>
      ) : (
        <>
          <button
            type="button"
            className={cn(
              "bg-panel-foreground text-sm rounded-sm h-8 px-3 whitespace-nowrap",
              isSolving && "bg-disabled text-dark-disabled cursor-default",
            )}
            onClick={() => {
              window.scrollTo(0, 0);
              onHandleSolveAgain();
              if (isCompleted) {
                handleUncompleteSBC();
              }
            }}
            disabled={isSolving}
          >
            Solve Again
          </button>
          {!hideGearIcon && (
            <button
              type="button"
              className="bg-panel-foreground h-8 px-2 rounded-sm"
              onClick={onToggleFiltersBar}
            >
              {gearIcon}
            </button>
          )}
        </>
      )}
    </div>
  );
};
